import { actorByType } from "../../utils/actors";
import type { TeleconsultoriaAgendaSummary } from "../types";

const SLOT_DURATION_EXTENSION = "schedule-slot-duration";
const ANTICIPATION_EXTENSION = "schedule-slot-anticipation-period";

/** Valor numérico de uma extension valueDuration (gravada como texto no PostSchedule). */
function durationValue(schedule: fhir5.Schedule, urlPart: string): number | undefined {
  const raw = schedule.extension?.find((extension) => extension.url?.includes(urlPart))
    ?.valueDuration?.value;
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : undefined;
}

/** Schedule → resumo exibido no card da agenda. */
export function toAgendaSummary(schedule: fhir5.Schedule): TeleconsultoriaAgendaSummary | undefined {
  if (!schedule.id) return undefined;
  return {
    schedule,
    id: schedule.id,
    name: schedule.name || "Agenda de teleconsultoria",
    isActive: schedule.active !== false,
    practitioner: actorByType(schedule.actor, "Practitioner"),
    healthcareServiceName: actorByType(schedule.actor, "HealthcareService")?.display || "",
    locationName: actorByType(schedule.actor, "Location")?.display || "",
    periodStart: schedule.planningHorizon?.start,
    periodEnd: schedule.planningHorizon?.end,
    slotDurationMinutes: durationValue(schedule, SLOT_DURATION_EXTENSION),
    anticipationDays: durationValue(schedule, ANTICIPATION_EXTENSION),
  };
}

/** Ativas primeiro; depois por profissional e nome. */
export function sortAgendaSummaries(
  summaries: TeleconsultoriaAgendaSummary[],
): TeleconsultoriaAgendaSummary[] {
  return [...summaries].sort((first, second) => {
    if (first.isActive !== second.isActive) return first.isActive ? -1 : 1;
    const byPractitioner = (first.practitioner?.display || "").localeCompare(
      second.practitioner?.display || "",
      "pt-BR",
    );
    return byPractitioner || first.name.localeCompare(second.name, "pt-BR");
  });
}
